<template>
    <div style="height: 100%;">
        <div class="header mt-8">
            <div class="text-header">
                {{ $vuetify.lang.t('$vuetify.checkInLocationDetail.viewAttendance') }}
            </div>
        </div>
        <div v-if="isLoadingData === false" class="wrapper-layout">
            <div class="employee-info">
                <v-card class="card-height">
                    <div class="head-line">{{ $vuetify.lang.t('$vuetify.checkInLocationDetail.profile') }}</div>
                    <v-row>
                        <v-col cols="3" class="pt-0 profile-container d-flex-center">
                            <profile :img="employeeInfo.employeeImg"/>
                        </v-col>
                        <v-col cols="9" class="pt-0">
                            <v-row>
                                <v-col cols="6" class="pt-0">
                                    <div class="mb-4">
                                        <div class="form-label">
                                            {{ $vuetify.lang.t('$vuetify.checkInLocationDetail.name') }}
                                        </div>
                                        <div class="form-text">{{ employeeInfo.fullname }}</div>
                                    </div>
                                    <div class="mb-4">
                                        <div class="form-label">
                                            {{ $vuetify.lang.t('$vuetify.checkInLocationDetail.department') }}
                                        </div>
                                        <div class="form-text">{{ employeeInfo.department }}</div>
                                    </div>
                                    <div class="mb-4">
                                        <div class="form-label">
                                            {{ $vuetify.lang.t('$vuetify.checkInLocationDetail.startDate') }}
                                        </div>
                                        <div class="form-text">{{ employeeInfo.startDate }}</div>
                                    </div>
                                    <div class="mb-4">
                                        <div class="form-label">
                                            {{ $vuetify.lang.t('$vuetify.checkInLocationDetail.status') }}
                                        </div>
                                        <div class="form-text">{{ employeeInfo.status }}</div>
                                    </div>
                                </v-col>
                                <v-col cols="6" class="pt-0">
                                    <div class="mb-4">
                                        <div class="form-label">
                                            {{ $vuetify.lang.t('$vuetify.checkInLocationDetail.employeeNo') }}
                                        </div>
                                        <div class="form-text">{{ employeeInfo.employeeNo }}</div>
                                    </div>
                                    <div class="mb-4">
                                        <div class="form-label">
                                            {{ $vuetify.lang.t('$vuetify.checkInLocationDetail.group') }}
                                        </div>
                                        <div class="form-text">{{ employeeInfo.group }}</div>
                                    </div>
                                    <div class="mb-4">
                                        <div class="form-label">
                                            {{ $vuetify.lang.t('$vuetify.checkInLocationDetail.endDate') }}
                                        </div>
                                        <div class="form-text">{{ employeeInfo.endDate }}</div>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-card>
            </div>
            <div class="employee-contact">
                <v-card class="card-height">
                    <div class="head-line">
                        {{ $vuetify.lang.t('$vuetify.checkInLocationDetail.contact') }}
                    </div>
                    <v-row>
                        <v-col cols="6" class="pt-0 d-flex-align-center">
                            <div class="bg-icon">
                                <v-icon
                                    color="#d76436"
                                >
                                    mdi-email
                                </v-icon>
                            </div>
                            <div>
                                <div class="form-label">
                                    {{ $vuetify.lang.t('$vuetify.checkInLocationDetail.email') }}
                                </div>
                                <div class="form-text">{{ employeeContact.email }}</div>
                            </div>
                        </v-col>
                        <v-col cols="6" class="pt-0 d-flex-align-center">
                            <div class="bg-icon">
                                <v-icon
                                    color="#d76436"
                                >
                                    mdi-phone
                                </v-icon>
                            </div>
                            <div>
                                <div class="form-label">
                                    {{ $vuetify.lang.t('$vuetify.checkInLocationDetail.phoneNumber') }}
                                </div>
                                <div class="form-text">{{ employeeContact.phone }}</div>
                            </div>
                        </v-col>
                    </v-row>
                </v-card>
            </div>
            <div class="check-in-detail">
                <v-card class="card-height">
                    <div class="head-line">{{ $vuetify.lang.t('$vuetify.checkInLocationDetail.checkInDetail') }}</div>
                    <div class="d-flex mb-6">
                        <div class="mr-8">
                            <div class="form-label">
                                {{ $vuetify.lang.t('$vuetify.checkInLocationDetail.date') }}
                            </div>
                            <div class="form-text">
                                {{ checkInDetail.date }}
                            </div>
                        </div>
                        <div>
                            <div class="form-label">
                                {{ $vuetify.lang.t('$vuetify.checkInLocationDetail.time') }}
                            </div>
                            <div class="form-text">
                                {{ checkInDetail.time }}
                            </div>
                        </div>
                    </div>
                    <div class="mb-4">
                        <div class="form-label mb-3">
                            {{ $vuetify.lang.t('$vuetify.checkInLocationDetail.checkInLocation') }}
                        </div>
                        <div class="box-location-name">
                            <div class="icon-container">
                                <i class="fas fa-map-marker-alt item-list-icon"></i>
                            </div>
                            <div class="location-name">
                                {{ checkInDetail.address }}
                            </div>
                            <div class="check-in-time">
                                {{ checkInDetail.time }}
                            </div>
                        </div>
                    </div>
                    <div class="mb-6">
                        <img v-if="checkInDetail.mapFile" class="map-border-radius" :src="checkInDetail.mapFile" alt="" width="100%" height="300px">
                    </div>
                    <div>
                        <div class="form-label mb-3">
                            {{ $vuetify.lang.t('$vuetify.checkInLocationDetail.attachmentFile') }}
                        </div>
                        <img v-if="checkInDetail.attachmentFile" class="map-border-radius" :src="checkInDetail.attachmentFile" alt="" width="50%">
                        <span v-else>-</span>
                    </div>
                </v-card>
            </div>
        </div>
    </div>
</template>

<script>
import Profile from '@/components/Profile'
import imgPath from '@/assets/user_default.png'
export default {
    name: 'CheckInLocationDetail',
    components: {
        Profile
    },
    data () {
        return {
            employeeInfo: {
                fullname: '',
                employeeNo: '',
                department: '',
                group: '',
                startDate: '',
                endDate: '',
                status: '',
                employeeImg: imgPath
            },

            employeeContact: {
                email: '',
                phone: ''
            },

            checkInDetail: {
                date: '',
                time: '',
                address: '',
                mapFile: '',
                attachmentFile: ''
            },
            checkIdLocationId: null,
            isLoadingData: true
        }
    },

    methods: {
        async getLocationDetail () {
            this.$store.dispatch('setLoading', true)
            const res = await this.axios.get(`attendances/check-in-location/${this.checkIdLocationId}`)
            if (res && res.data && res.data.status === 'ok') {
                this.isLoadingData = false
                const data = res.data.data
                this.employeeInfo = data.employeeInfo
                this.employeeContact = data.employeeContact
                this.checkInDetail = data.checkInDetail
                if (this.employeeInfo.employeeImg === null) {
                    this.employeeInfo.employeeImg = imgPath
                }
            } else {
                this.$router.push({ name: 'CheckInLocation' }, () => {})
            }
            this.$store.dispatch('setLoading', false)
        }
    },
    async mounted () {
        this.checkIdLocationId = this.$route.params.id
        await this.getLocationDetail()
    },

    watch: {
        '$vuetify.lang.current': {
            handler: async function (after, before) {
                await this.getLocationDetail()
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
.wrapper-layout {
    padding: 2rem 0;
    display: grid;
    grid-template-columns: 60% 40%;
    grid-gap: 2rem;
    .employee-info {
        grid-column: 1;
        grid-row: 1;
    }
    .employee-contact {
        grid-column: 1;
        grid-row: 2;
        height: fit-content;
    }
    .check-in-detail {
        grid-column: 2;
        grid-row: 1/5;
    }
}

.card-height {
    padding: 2rem;
    border-radius: 15px !important;
}

.form-label {
    font-size: 14px;
    color: #6c6c6c;
    line-height: 1.29;
    margin-bottom: 5px;
}
.form-text {
    font-family: Roboto;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    color: #131410;
}

.head-line {
    font-family: LexendDeca;
    font-size: 24px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.25;
    letter-spacing: normal;
    text-align: left;
    color: #000;
    margin-bottom: 2rem;
}

.bg-icon {
    width: 36px;
    height: 36px;
    background-color: #faede7;
    border-radius: 5px;
    margin-right: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.box-location-name {
    background-color: #f9f1e6;
    font-size: 16px;
    border-radius: 10px;
    display: flex;
    padding: 1rem;
    .icon-container {
        width: 10%;
        color: #e8ac8f;
    }

    .location-name {
        width: 70%;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.44;
        letter-spacing: normal;
        text-align: left;
        color: #131410;
    }

    .check-in-time {
        width: 20%;
        text-align: right;
        color: #a8a8a8;
        font-weight: normal;
    }

}
.map-border-radius {
    border-radius: 40px;
}
</style>
